import { createAsyncThunk } from '@reduxjs/toolkit';
import { ReportsApi, SaveOfferData } from 'api/ReportsApi';

interface SaveSelectedOfferParams {
  applicationId: string;
  data: SaveOfferData;
}

export const createSaveSelectedOfferThunk = (api: ReportsApi) =>
  createAsyncThunk('reports/saveSelectedOffer', async (params: SaveSelectedOfferParams, thunkApi) => {
    try {
      const { applicationId, data } = params;
      return await api.saveSelectedOffer(applicationId, data);
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  });
